import request from '@/utils/request'
import { apiUrl } from './config'
type dataType = any
export default {
    //九方热榜
    hotList(data: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: apiUrl + '/rjhy-finance/api/1/hot/stock/list',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
            },
            sign: true
        })
    },
    //分时排名
    hotMin(data: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: apiUrl + '/rjhy-finance/api/1/stock/hot/min10',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
            },
            sign: true
        })
    },
    //历史排名
    hotHis(data: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: apiUrl + '/rjhy-finance/api/1/stock/hot/his',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
            },
            sign: true
        })
    },
    //概念榜、行业榜
    hotPList(data: dataType, headers?: any): Promise<{
        response?: Response
    }> {
        return request({
            url: apiUrl + '/rjhy-quote-sector/api/2/hot/plate/list',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                ...headers
            },
            sign: true
        })
    }
}